import { Injectable, signal } from '@angular/core';
import type { SignInForm } from '@core/auth/components/sign-in/models/sign-in.model';

@Injectable({
  providedIn: 'root'
})
export class SignInStateService {
  private formData = signal<SignInForm>({
    email: '',
    password: '',
    rememberMe: false
  });

  saveFormData(data: SignInForm) {
    this.formData.set(data);
  }

  getFormData() {
    return this.formData();
  }

  clearFormData() {
    this.formData.set({
      email: '',
      password: '',
      rememberMe: false
    });
  }
}
